import { render, staticRenderFns } from "./SageAvatar.vue?vue&type=template&id=47ef0f68&scoped=true"
import script from "./SageAvatar.vue?vue&type=script&lang=js"
export * from "./SageAvatar.vue?vue&type=script&lang=js"
import style0 from "./SageAvatar.vue?vue&type=style&index=0&id=47ef0f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef0f68",
  null
  
)

export default component.exports